import React, { useState } from 'react';
import styled from 'styled-components';
import * as taskService from '../services/taskService';

const DeleteButton = styled.button`
  background-color: rgba(255, 59, 48, 0.1);  /* Apple red with transparency */
  color: #FF3B30;  /* Apple red */
  border: none;
  border-radius: 6px;
  padding: 0.4rem 0.75rem;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
  margin-left: 0.5rem;
  display: flex;
  align-items: center;
  
  &:hover {
    background-color: rgba(255, 59, 48, 0.2);
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  &:disabled {
    background-color: rgba(255, 59, 48, 0.05);
    color: rgba(255, 59, 48, 0.5);
    cursor: not-allowed;
  }
`;

const ErrorMessage = styled.div`
  color: #FF3B30;
  font-size: 0.75rem;
  margin-top: 0.25rem;
`;

const DeleteIcon = () => (
  <svg 
    width="14" 
    height="14" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
    style={{ marginRight: '4px' }}
  >
    <polyline points="3 6 5 6 21 6"></polyline>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
  </svg>
);

const DeleteTaskButton = ({ taskId, taskTitle, onSuccess }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState(null);

  const handleDelete = async (e) => {
    // Stop event propagation to prevent triggering parent click
    e.stopPropagation();
    
    if (!window.confirm(`Are you sure you want to delete task "${taskTitle || 'Untitled'}"?`)) {
      return;
    }
    
    setIsDeleting(true);
    setError(null);
    
    try {
      const result = await taskService.deleteTask(taskId);
      
      if (result.success || !result.error) {
        console.log('Task deleted successfully');
        if (onSuccess) onSuccess(taskId);
      } else {
        setError(result.error || 'Failed to delete task');
      }
    } catch (error) {
      console.error('Error deleting task:', error);
      setError(error.message || 'Failed to delete task');
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      <DeleteButton onClick={handleDelete} disabled={isDeleting}>
        <DeleteIcon />
        {isDeleting ? 'Deleting...' : 'Delete'}
      </DeleteButton>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </>
  );
};

export default DeleteTaskButton; 